import React, { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { faListCheck } from '@fortawesome/pro-light-svg-icons';
import { BlockTitle } from 'src/shared';
import PrePopulateModal from '../PrePopulateModal';
import { Button, Tooltip } from 'src/common';
import { useBidding } from 'src/models/bids/BidFull/hooks';
import { useTenderNavData } from 'src/models/procurements/TenderNav/hooks';

export const TasksHeading: FC = () => {
  const { t } = useTranslation();
  const { data: biddingData, loading } = useBidding();
  const { data: tenderNavData } = useTenderNavData();
  const fileCategories = tenderNavData?.filesCats || [];

  const [modalVisible, setModalVisible] = useState(false);

  const onClose = useCallback(() => {
    setModalVisible(false);
  }, []);

  return (
    <section className={styles.heading}>
      <BlockTitle icon={{ defaultIcon: faListCheck }} title={t('BiddingTool.bidSubmission')} className={styles.title} />
      <div className={styles.subHeading}>
        <p className={styles.desc}> {t('BiddingTool.bidSubmissionTips')}</p>
        {loading || !fileCategories.length ? (
          <Tooltip title={t('BiddingTool.prePopuldateButtonDisabledDesc')}>
            <div className={styles.disabledButton}>
              <Button type={'primary'} className={styles.button} disabled>
                {t('BiddingTool.prePopulateButton')}
              </Button>
            </div>
          </Tooltip>
        ) : (
          <>
            <Button type={'primary'} onClick={() => setModalVisible(true)} className={styles.button}>
              {t('BiddingTool.prePopulateButton')}
            </Button>
            {modalVisible ? (
              <PrePopulateModal biddingData={biddingData} tenderNavData={tenderNavData} onCloseModal={onClose} />
            ) : null}
          </>
        )}
      </div>
    </section>
  );
};

export default TasksHeading;
